import * as React from 'react';

import Routes from 'routes/Index';

export const App = (): JSX.Element => <Routes />;
